interface Colors {
  primary: string;
  primaryDark: string;
  primaryLight: string;
  secondary: string;
  secondaryDark: string;
  secondaryLight: string;
  skyBlue: string;
  pink: string;
  green: string;
}

const colors: Colors = {
  primary: "#0055B8",
  primaryDark: "#00263D",
  primaryLight: "#8AB7E9",
  secondary: "#0066FF",
  secondaryDark: "#012376",
  secondaryLight: "#EEEEEE",
  skyBlue: "#C2E1E4",
  pink: "#EAA7FD",
  green: "#A5FF76",
};

export default colors;
